<template>
  <div>
    <lcontainer class="mb-4">
      <div class="heading flex flex-row items-center justify-between py-2 px-8">
        <div>
          <div class="page text-white mb-4">Program Management</div>
          <lms-button
            color="#fff"
            @click="
              $router.push({
                name: 'create-program',
              })
            "
            >Add Program</lms-button
          >
        </div>
        <div>
          <img :src="require('../../../assets/tenant_image.png')" alt="" />
        </div>
      </div>
    </lcontainer>
    <lcontainer>
      <div class="flex justify-between">
        <page-header class="py-2 tenant-main-color">Programs</page-header>
        <div class="flex m-2"></div>
      </div>
      <hr class="mx-4" />
      <div class="mx-8 mt-4">
        <linput
          v-model="search"
          class="py-2"
          placeholder="Search by Program Name"
        />
      </div>
      <div />
      <div class="flex flex-wrap">
        <program-card
          v-for="program in getTenantPrograms"
          :key="program.id"
          :program="program"
        />
      </div>
    </lcontainer>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  components: {
    ProgramCard: () => import("@/components/tenant/program-card"),
    LmsButton: () => import("@/components/general/button"),
    lcontainer: () => import("@/components/general/container"),
    LmsTable: () => import("@/components/admin/admin-table"),
    PageHeader: () => import("@/components/general/pageheader"),
    LmsSelect: () => import("@/components/forms/select"),
    linput: () => import("@/components/general/input"),
  },
  data() {
    return {
      form: {},
      error: {},
      search: "",
      sort: [
        { text: "Name", value: "Name" },
        { text: "Email", value: "Email" },
      ],
      filter: [
        { text: "Tenants assigned to me", value: "Tenants assigned to me" },
        { text: "All Tenants", value: "All Tenants" },
      ],
    };
  },
  methods: {
    ...mapMutations(["updateLoader"]),
    ...mapActions(["fetchTenantPrograms", "deleteTenantProgram"]),
    loadData() {
      this.updateLoader(true);
      this.fetchTenantPrograms();
      this.updateLoader(false);
    },
  },
  computed: {
    ...mapGetters(["getTenantPrograms"]),
  },
  mounted() {
    this.$Bus.$on("fetch-programs", (data) => {
      this.loadData();
    });
    this.loadData();
  },
};
</script>
<style scoped></style>
